import React from 'react';
import styles from './Home.module.scss';
import Displaybyletter from '../../DisplayByLetter/Displaybyletter';
import { BASIC_CONTENT, HOME_TEXT_TODISPLAY } from '../../../App.constant';
import angleDown from '../../../assets/angle-down-solid.svg';
import { Button } from '@mui/material';

// eslint-disable-next-line react/prop-types
function Home({ setActiveTab }) {
  const scrollPage = (tab) => {
    const targetElement = document.getElementById(tab);
    if (targetElement) {
      // Scroll smoothly to the target element
      targetElement.scrollIntoView({ behavior: 'smooth' });
      setActiveTab(tab);
      // Update the URL hash
      window.history.pushState(null, null, `#${tab}`);
    } else {
      alert('Element not found');
    }
  };

  return (
    <div className={styles.homeContainer} id='home'>
      <div className={styles.outerLayer}></div>
      <div className={styles.content}>
        <h2>Welcome</h2>
        <Displaybyletter text={HOME_TEXT_TODISPLAY} />
        <h4>{BASIC_CONTENT.from}</h4>
        {/* OnClick scrolls to the 'contact' section */}
        <Button
          variant="contained"
          color="primary"
          className={styles.getInTouch}
          onClick={() => scrollPage('contact')}>
          Get In Touch
        </Button>
      </div>
      <figure className={styles.downArrow}>
        <img
          src={angleDown}
          onClick={() => {
            scrollPage('about');
          }}
        />
      </figure>
    </div>
  );
}

export default Home;

